module.exports = __webpack_public_path__ + "img/share.abad20e9.svg";